import { render, staticRenderFns } from "./addEditSkuMapping.vue?vue&type=template&id=979d371e&scoped=true&"
import script from "./addEditSkuMapping.vue?vue&type=script&lang=tsx&"
export * from "./addEditSkuMapping.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979d371e",
  null
  
)

export default component.exports